module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.venue['.key']) ? _c('div', {
    staticClass: "col-12 venue"
  }, [(_vm.$store.getters.user !== null) ? _c('b-button-toolbar', {
    staticClass: "float-right",
    attrs: {
      "aria-label": "Toolbar",
      "is-nav-bar": ""
    }
  }, [_c('b-button-group', [_c('b-btn', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.editionForm",
      modifiers: {
        "editionForm": true
      }
    }],
    staticClass: "m-1"
  }, [_vm._v("Edit Venue")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-collapse', {
    attrs: {
      "id": "editionForm"
    }
  }, [_c('venue-edit', {
    staticClass: "border border-top-0 border-right-0 border-left-0 mb-3 pb-3",
    attrs: {
      "venue": _vm.venue
    }
  })], 1), _vm._v(" "), _c('venue-preview', {
    attrs: {
      "venue": _vm.venue
    }
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1baa77c2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Venue/View.vue
// module id = 658
// module chunks = 1